<script>
import { activeStep } from './lib.js';
import ChooseModel from './ChooseModel.svelte';
import ChooseExterior from './ChooseExterior.svelte';
import ChooseFloorplan from './ChooseFloorplan.svelte';
import ChooseInterior from './ChooseInterior.svelte';
import ChooseSpecs from './ChooseSpecs.svelte';
import Summary from './Summary.svelte';

$activeStep = 0;

$: (() => {
	($activeStep)
	window.html = false;
	var form = document.querySelector('#modal-popup-save form');
	if(form) {
		form.style.display = 'block';
	}
	var msg = document.querySelector('#modal-popup-save .nf-response-msg');
	if(msg) {
		msg.style.display = 'none';
	}
})()
</script>
<div class="build-your-own">
    <div class="byo-wrapper">
        <nav class="byo-top-nav js-byo-secondary">
            <div class="byo-top-nav__inner">
                <ul class="byo-top-nav__list">
                    <li class="byo-top-nav__list-item"><button on:click={() => $activeStep = 0} class="byo-top-nav__link js-nav-link {$activeStep == 0 ? 'isActive' : '' }"> 01. Models </button></li>
                    <li class="byo-top-nav__list-item"><button on:click={() => $activeStep = 1} disabled="{$activeStep < 1}" class="byo-top-nav__link js-nav-link {$activeStep == 1 ? 'isActive' : '' }"> 02. Exterior </button></li>
                    <li class="byo-top-nav__list-item"><button on:click={() => $activeStep = 2} disabled="{$activeStep < 2}" class="byo-top-nav__link js-nav-link {$activeStep == 2 ? 'isActive' : '' }"> 03. Floor Plan </button></li>
                    <li class="byo-top-nav__list-item"><button on:click={() => $activeStep = 3} disabled="{$activeStep < 3}" class="byo-top-nav__link js-nav-link {$activeStep == 3 ? 'isActive' : '' }"> 04. Interior </button></li>
                    <li class="byo-top-nav__list-item"><button on:click={() => $activeStep = 4} disabled="{$activeStep < 4}" class="byo-top-nav__link js-nav-link {$activeStep == 4 ? 'isActive' : '' }"> 05. Specs </button></li>
                    <li class="byo-top-nav__list-item"><button on:click={() => $activeStep = 5} disabled="{$activeStep < 5}" class="byo-top-nav__link js-nav-link {$activeStep == 5 ? 'isActive' : '' }"> 06. Summary </button></li>
                </ul>
            </div>
        </nav>
        <div class="byo">
            {#if $activeStep == 0}
                <ChooseModel></ChooseModel>
            {:else if $activeStep == 1}
                <ChooseExterior></ChooseExterior>
            {:else if $activeStep == 2}
                <ChooseFloorplan></ChooseFloorplan>
            {:else if $activeStep == 3}
                <ChooseInterior></ChooseInterior>
            {:else if $activeStep == 4}
                <ChooseSpecs></ChooseSpecs>
            {:else if $activeStep == 5}
                <Summary></Summary>
            {/if}
        </div>
    </div>
</div>

<style>
.byo {
    background: #f0f0f0;
}
</style>
